export const environment = {
  configuration: 'development',
  production: false,
  backend: 'https://api.innovationhub.dev.agco-opsmgmt.com',
  portal: {
    osm: 'https://api.v1.o2isvc.dev.agco-opsmgmt.com/osm2isoxml',
    guidance: 'https://api.v3.dxfamt.dev.agco-opsmgmt.com',
    guidanceBucket: 'https://dxfamt-data-bucket-8540de7b-ddf6-e475-f522-0351e6e855fc.s3.amazonaws.com/',
    guidanceWebsocket: 'wss://ws.v3.dxfamt.dev.agco-opsmgmt.com',
  },
  analytics: {
    link: 'https://dashboard.simpleanalytics.com/innovationhub.dev.agco-opsmgmt.com',
    script: 'https://info.agco-innovationhub.com/latest.dev.js',
    hostName: 'innovationhub.dev.agco-opsmgmt.com',
  },
  Auth: {
    domain: 'operational-planning.auth.eu-central-1.amazoncognito.com',
    userPoolId: 'eu-central-1_L0XzyMqKo',
    userPoolClientId: '3qrp0sqhtoi35o47l3mh5p7j14',
    redirectSignIn: 'https://innovationhub.dev.agco-opsmgmt.com',
    redirectSignOut: 'https://innovationhub.dev.agco-opsmgmt.com',
    test: {
      user: {
        email: 'agcoinnovationhub-testuser@mailinator.com',
        password: '4^C$AjkzM6CmL$K@tfH',
      },
      admin: {
        email: 'tomquast89+testfull@gmail.com',
        password: '4^C$AjkzM6CmL$K@tfH-full',
      },
    },
  },
};
